import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/activitys/logo.png';
import _imports_1 from '../../assets/activitys/title.png';
const _withScopeId = n => (_pushScopeId("data-v-319f92a6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "content"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "logo",
  src: _imports_0
}, null, -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [/*#__PURE__*/_createElementVNode("img", {
  class: "title",
  src: _imports_1
})], -1));
const _hoisted_4 = {
  class: "detail"
};
const _hoisted_5 = {
  class: "activitys"
};
const _hoisted_6 = {
  class: "list"
};
const _hoisted_7 = {
  class: "swiper-container",
  ref: "swiperList"
};
const _hoisted_8 = {
  class: "swiper-wrapper"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = ["src"];
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "pagination"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`activitysIndex ${this.isMobile ? 'h5' : ''}`)
  }, [_createElementVNode("div", _hoisted_1, [_hoisted_2, _hoisted_3, _createElementVNode("div", _hoisted_4, [_createElementVNode("div", {
    class: "pintu",
    onClick: _cache[0] || (_cache[0] = $event => $options.toDetail(0))
  }), _createElementVNode("div", {
    class: "dati",
    onClick: _cache[1] || (_cache[1] = $event => $options.toDetail(1))
  })]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", {
    class: "icon",
    onClick: _cache[2] || (_cache[2] = $event => $options.toDetail(2, _ctx.item))
  }), _createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.activityList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "swiper-slide navItem",
      onClick: $event => $options.openDetail(item.url)
    }, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_10), _createElementVNode("div", _hoisted_11, _toDisplayString(item.name), 1)], 8, _hoisted_9);
  }), 256))])], 512), _hoisted_12])])])], 2);
}